import workspaceQuery from '../../queries/supplier/SuggestedPaymentWorkspaceQuery.graphql';
import instanceQuery from '../../queries/supplier/SuggestedPaymentQuery.graphql';
import defaultQuery from '../../queries/supplier/SuggestedPaymentDefault.graphql';
import generationQuery from '../../mutations/supplier/SuggestedPaymentGeneration.graphql';
import postQuery from '../../mutations/supplier/SuggestedPaymentPost.graphql';
import mutationQuery from '../../mutations/supplier/SuggestedPaymentMutation.graphql';
import temporaryMutationQuery from '../../mutations/supplier/SaveSuggestedPaymentTempMutation.graphql';
import fragment from '../../fragments/supplier/SuggestedPaymentFragment.graphql';
import temporaryQuery from '../../queries/supplier/SuggestedPaymentTempDefault.graphql';
import { supplierDocument } from '../../../utils/mailMergeFields';
import { EntityType, IFormActions } from '../../../@types/entityTypes';
import { DocumentNode } from '@apollo/client';

export enum SuggestedPaymentAction {
  GenerateSuggestedPayment = 'GENERATE_SUGGESTED_PAYMENT',
  PostSuggestedPayment = 'POST_SUGGESTED_PAYMENT',
  PrintRemittance = 'PRINT_REMITTANCE',
  PrintDynamicReport = 'PRINT_DYNAMIC_REPORT',
}

const formActionsForPermissions: IFormActions<SuggestedPaymentAction> = [
  {
    actionReference: SuggestedPaymentAction.GenerateSuggestedPayment,
  },
  {
    actionReference: SuggestedPaymentAction.PostSuggestedPayment,
  },
  {
    actionReference: SuggestedPaymentAction.PrintRemittance,
  },
  {
    actionReference: SuggestedPaymentAction.PrintDynamicReport,
  },
];

const SuggestedPayment: EntityType & { post?: DocumentNode } = {
  type: 'SuggestedPayment',
  title: 'Suggested Supplier Payments',
  formTitle: 'Suggested Supplier Payments',
  formUrl: '/Suppliers/SuggestedPayment/Details/',
  workspaceUrl: '/Suppliers/SuggestedPayment/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  generate: generationQuery,
  post: postQuery,
  temporary: temporaryQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'SUPPLIER_SUGGEST_PAYMENT',
  actions: [...formActionsForPermissions],
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
  mergeFields: supplierDocument,
};

export default SuggestedPayment;
